// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-menu-admin{
    padding-top: 15px;
    justify-content: center;
    display: flex;
    gap: 20px;
}
.mg-currencyLocation--main-div .mg-currency-show {
    position: absolute;
    left: 0;
    right: 0;
    width: 50%;
    margin: 0 auto;
    top: 0;
    height: 100%;
}

.mg-currencyLocation--main-div input[type="checkbox"] {
    width: 18px;
    height: 18px;
}

.mg-currencyLocation--main-div img {
    width: 100%;
    height: auto;
    margin-left: -40px;
}

.mg-currencyLocation--main-div {
    position: relative;
}
.mg-currencyLocation--main-div .mg-currency-show div:first-child {
    position: absolute;
    left: 0;
    top: 30px;
}

.mg-currencyLocation--main-div .mg-currency-show div:nth-child(2) {
    position: absolute;
    right: 0;
    top: 30px;
}

.mg-currencyLocation--main-div .mg-currency-show div:nth-child(3) {
    position: absolute;
    left: 0;
    bottom: 62px;
}

.mg-currencyLocation--main-div .mg-currency-show div:nth-child(4) {
    position: absolute;
    right: 0;
    bottom: 62px;
}

.Polaris-TextField{
    min-height: 44px;
}

.toggle-switch {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 55px;  /* Adjust width */
    height: 30px; /* Adjust height */
    background-color: gray;
    border-radius: 15px;
    padding: 3px;
    cursor: pointer;
    transition: background 0.3s ease-in-out;
    position: relative;
}

.toggle-switch.yes {
    background-color: green;
}

.toggle-switch.no {
    background-color: gray;
}

.toggle-circle {
    width: 24px; /* Smaller circle */
    height: 24px;
    background: white;
    border-radius: 50%;
    position: absolute;
    transition: transform 0.3s ease-in-out;
}

.yes .toggle-circle {
    transform: translateX(25px); /* Moves to right */
}

.no .toggle-circle {
    transform: translateX(0);
}

.Polaris-Tabs__TabContainer{
    width: 20%;
}

.Polaris-Tabs__Tab--active{
    background-color: var(--p-color-bg-surface);
}

.Polaris-Tabs__Tab:not([aria-disabled='true']):hover{
    background-color: var(--p-color-bg-surface);
}
.Polaris-Tabs__Tab:not([aria-disabled='false']):hover{
    background-color: var(--p-color-bg-surface);
}

.store-integration-ul{
    list-style-type: decimal;
}

.store-integration-ul li {
    margin-top:0.8rem;
}

.store-integration-ul li ::marker{
    font-weight: 700;
}

.store-integration-message-div{
    display: flex;
    margin-top: 1rem;
    justify-content: center;
}
.store-integration-html-with-currency-div{
    margin-top: 1rem;
    margin-bottom: 1rem;
    width : 75%;
    margin-left: 5rem;
}
.store-integration-html-with-currency-div .Polaris-Label {
    margin-bottom: 0.4rem;
}
.store-integration-html-with-currency-div .Polaris-Label span{
    font-size : 1rem;
}


.Polaris-Modal-Dialog__Modal .Polaris-Box .Polaris-Button[aria-label="Close"]{
    display: none !important;
}
.mg-faq-basic-faq{
    display: inline-grid;
    gap:20px;
}

.mg-faq-basic-faq dd{
    display: inline-grid;
    gap:5px;
}
.mg-faq-basic-faq dd p{
    margin-left: 25px;
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/style.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,uBAAuB;IACvB,aAAa;IACb,SAAS;AACb;AACA;IACI,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,UAAU;IACV,cAAc;IACd,MAAM;IACN,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,OAAO;IACP,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW,GAAG,iBAAiB;IAC/B,YAAY,EAAE,kBAAkB;IAChC,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,uCAAuC;IACvC,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW,EAAE,mBAAmB;IAChC,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,sCAAsC;AAC1C;;AAEA;IACI,2BAA2B,EAAE,mBAAmB;AACpD;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,2CAA2C;AAC/C;AACA;IACI,2CAA2C;AAC/C;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,uBAAuB;AAC3B;AACA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;IACX,iBAAiB;AACrB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,gBAAgB;AACpB;;;AAGA;IACI,wBAAwB;AAC5B;AACA;IACI,oBAAoB;IACpB,QAAQ;AACZ;;AAEA;IACI,oBAAoB;IACpB,OAAO;AACX;AACA;IACI,iBAAiB;AACrB","sourcesContent":[".header-menu-admin{\r\n    padding-top: 15px;\r\n    justify-content: center;\r\n    display: flex;\r\n    gap: 20px;\r\n}\r\n.mg-currencyLocation--main-div .mg-currency-show {\r\n    position: absolute;\r\n    left: 0;\r\n    right: 0;\r\n    width: 50%;\r\n    margin: 0 auto;\r\n    top: 0;\r\n    height: 100%;\r\n}\r\n\r\n.mg-currencyLocation--main-div input[type=\"checkbox\"] {\r\n    width: 18px;\r\n    height: 18px;\r\n}\r\n\r\n.mg-currencyLocation--main-div img {\r\n    width: 100%;\r\n    height: auto;\r\n    margin-left: -40px;\r\n}\r\n\r\n.mg-currencyLocation--main-div {\r\n    position: relative;\r\n}\r\n.mg-currencyLocation--main-div .mg-currency-show div:first-child {\r\n    position: absolute;\r\n    left: 0;\r\n    top: 30px;\r\n}\r\n\r\n.mg-currencyLocation--main-div .mg-currency-show div:nth-child(2) {\r\n    position: absolute;\r\n    right: 0;\r\n    top: 30px;\r\n}\r\n\r\n.mg-currencyLocation--main-div .mg-currency-show div:nth-child(3) {\r\n    position: absolute;\r\n    left: 0;\r\n    bottom: 62px;\r\n}\r\n\r\n.mg-currencyLocation--main-div .mg-currency-show div:nth-child(4) {\r\n    position: absolute;\r\n    right: 0;\r\n    bottom: 62px;\r\n}\r\n\r\n.Polaris-TextField{\r\n    min-height: 44px;\r\n}\r\n\r\n.toggle-switch {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    width: 55px;  /* Adjust width */\r\n    height: 30px; /* Adjust height */\r\n    background-color: gray;\r\n    border-radius: 15px;\r\n    padding: 3px;\r\n    cursor: pointer;\r\n    transition: background 0.3s ease-in-out;\r\n    position: relative;\r\n}\r\n\r\n.toggle-switch.yes {\r\n    background-color: green;\r\n}\r\n\r\n.toggle-switch.no {\r\n    background-color: gray;\r\n}\r\n\r\n.toggle-circle {\r\n    width: 24px; /* Smaller circle */\r\n    height: 24px;\r\n    background: white;\r\n    border-radius: 50%;\r\n    position: absolute;\r\n    transition: transform 0.3s ease-in-out;\r\n}\r\n\r\n.yes .toggle-circle {\r\n    transform: translateX(25px); /* Moves to right */\r\n}\r\n\r\n.no .toggle-circle {\r\n    transform: translateX(0);\r\n}\r\n\r\n.Polaris-Tabs__TabContainer{\r\n    width: 20%;\r\n}\r\n\r\n.Polaris-Tabs__Tab--active{\r\n    background-color: var(--p-color-bg-surface);\r\n}\r\n\r\n.Polaris-Tabs__Tab:not([aria-disabled='true']):hover{\r\n    background-color: var(--p-color-bg-surface);\r\n}\r\n.Polaris-Tabs__Tab:not([aria-disabled='false']):hover{\r\n    background-color: var(--p-color-bg-surface);\r\n}\r\n\r\n.store-integration-ul{\r\n    list-style-type: decimal;\r\n}\r\n\r\n.store-integration-ul li {\r\n    margin-top:0.8rem;\r\n}\r\n\r\n.store-integration-ul li ::marker{\r\n    font-weight: 700;\r\n}\r\n\r\n.store-integration-message-div{\r\n    display: flex;\r\n    margin-top: 1rem;\r\n    justify-content: center;\r\n}\r\n.store-integration-html-with-currency-div{\r\n    margin-top: 1rem;\r\n    margin-bottom: 1rem;\r\n    width : 75%;\r\n    margin-left: 5rem;\r\n}\r\n.store-integration-html-with-currency-div .Polaris-Label {\r\n    margin-bottom: 0.4rem;\r\n}\r\n.store-integration-html-with-currency-div .Polaris-Label span{\r\n    font-size : 1rem;\r\n}\r\n\r\n\r\n.Polaris-Modal-Dialog__Modal .Polaris-Box .Polaris-Button[aria-label=\"Close\"]{\r\n    display: none !important;\r\n}\r\n.mg-faq-basic-faq{\r\n    display: inline-grid;\r\n    gap:20px;\r\n}\r\n\r\n.mg-faq-basic-faq dd{\r\n    display: inline-grid;\r\n    gap:5px;\r\n}\r\n.mg-faq-basic-faq dd p{\r\n    margin-left: 25px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
